import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["locale"];
import React from 'react';
import { IntlProvider } from 'react-intl-next';
export var withIntlProvider = function withIntlProvider(WrappedComponent) {
  return function (props) {
    var locale = props.locale,
      rest = _objectWithoutProperties(props, _excluded);
    if (locale) {
      return /*#__PURE__*/React.createElement(IntlProvider, {
        locale: locale
      }, /*#__PURE__*/React.createElement(WrappedComponent, rest));
    }
    return /*#__PURE__*/React.createElement(WrappedComponent, rest);
  };
};